import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = HTMLAttributes<HTMLElement> & {
	className?: string;
	children: ReactNode;
	as?: "div" | "aside" | "section";
	elevated?: boolean;
};

export function FloatingCard({
	className,
	children,
	as = "div",
	elevated = true,
	...rest
}: Props) {
	const Tag = as;
	return (
		<Tag
			className={cn(
				"rounded-[var(--radius-panel)] bg-surface text-fg",
				elevated &&
					"shadow-[var(--shadow-float)] ring-1 ring-[var(--ring-hairline)]",
				className,
			)}
			{...rest}
		>
			{children}
		</Tag>
	);
}
